import { styled } from "@mui/material/styles";
import { SvgIconWrapper } from "../../svg-icon-wrapper.component";

export const MaximizeIconWrapper = styled(SvgIconWrapper)({
  width: "2rem",
  height: "2rem",
});
